var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18C19.25 17.5858 19.5858 17.25 20 17.25C20.4142 17.25 20.75 17.5858 20.75 18V21C20.75 21.9665 19.9665 22.75 19 22.75H5C4.0335 22.75 3.25 21.9665 3.25 21V18C3.25 17.5858 3.58579 17.25 4 17.25C4.41421 17.25 4.75 17.5858 4.75 18V21C4.75 21.1381 4.86193 21.25 5 21.25H19C19.1381 21.25 19.25 21.1381 19.25 21V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.50002C17.75 5.19668 17.9327 4.9232 18.213 4.80711C18.4932 4.69103 18.8158 4.75519 19.0303 4.96969L22.5303 8.46969C22.8232 8.76259 22.8232 9.23746 22.5303 9.53035L19.0303 13.0304C18.8158 13.2449 18.4932 13.309 18.213 13.1929C17.9327 13.0768 17.75 12.8034 17.75 12.5V9.75002H14C13.3096 9.75002 12.75 10.3097 12.75 11V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V11C11.25 9.48124 12.4812 8.25002 14 8.25002H17.75V5.50002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.82f2e077482741c75cd30449fa52cb7c.svg";
export { ForwardRef as ReactComponent };